import React from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AccountForm from "../../components/account/accountForm";
import { RevSkeleton } from "../../components/ds";

// Forma de la pantalla que se está pidiendo: la card de datos con sus dos rejillas (nombre,
// correo y teléfono, novedades e idioma; solo el idioma lleva ayuda), la zona de
// peligro y la card de resumen del aside con sus tres filas clave/valor.
const ESQUELETO = (t) => ({
    bloques: [
        {
            card: {
                campos: [
                    [null, null, null],
                    [{ control: 'switch' }, t('account.profile.lang.help')],
                ],
                divisor: true,
            },
        },
        {
            danger: {
                titulo: t('Delete my account'),
                texto: t('account.profile.delete.text'),
                accion: t('account.profile.delete.button'),
            },
        },
    ],
    aside: [{
        card: {
            kv: [
                t('account.profile.overview.balance'),
                t('account.profile.overview.activeEvents'),
                t('account.profile.overview.payouts'),
            ],
        },
    }],
    barra: [t('generic.saveButton.text')],
});

const AccountBasicData = ({ user, loading, postUser, deleteAccount, signOut, redirect, events, getUser }) => {
    const { t } = useTranslation();

    return (
        loading && !user?.id
            ? <RevSkeleton.Page forma="form" label={t('event.photos.loading')} {...ESQUELETO(t)} />
            : <AccountForm redirect={redirect} user={user} postUser={postUser} loading={loading} deleteAccount={deleteAccount} signOut={signOut} events={events} getUser={getUser}/>
    );
};

export default withRouter(AccountBasicData);
